import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import i18n from '../src/assets/i18n/langs/i18n';
import { Image as VanImage ,Skeleton,Toast} from 'vant';

const app = createApp(App);
app.use(Skeleton);
app.use(i18n);
app.use(router);
app.use(VanImage);
app.use(Toast);
app.mount("#app");
// const { proxy } = getCurrentInstance();
// proxy.$i18n.locale = 'en'
// app.$i18n.locale="en"


